import type { Authenticator, AuthState, BasicGrant, User } from '@creditornot/wolt-auth';

// NOTE: We assign the state object to a variable to maintain a stable object reference.
const state = {
  status: 'logged-in',
  user: {
    id: '',
    name: { first_name: '', last_name: '' },
    email: '',
    country: '',
    email_verified: true,
    profile_picture: { url: '' },
    roles: [],
    permissions: [],
  },
} satisfies AuthState<User>;

/**
 * This dummy authenticator exists solely to disable all client-side auth logic.
 * DoorDash user sessions are handled server-side, whereas Wolt user sessions
 * are still managed on the client.
 */
export const authenticator = {
  getState: () => state,
  login: async () => {},
  logout: async () => {},
  refreshUser: async () => {},
  getAccessToken: async () => '',
  subscribe: () => {},
  unsubscribe: () => {},
  unsubscribeAll: () => {},
} satisfies Authenticator<BasicGrant, User>;
